import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 48 48",
  style: {"enable-background":"new 0 0 48 48"},
  "xml:space": "preserve",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      style: {"fill":"currentColor"},
      d: "M45,3.1H3c-1.6,0-2.8,1.4-2.8,3.1v28C0.2,35.7,1.5,37,3,37h17.2c0,0,0,0,0,0c-0.1,2.5-1.1,5-2.8,7.1\n\tc-0.1,0.1-0.1,0.1-0.1,0.2H15c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8h18c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-2.3\n\tc0-0.1-0.1-0.1-0.1-0.2c-1.7-2.1-2.7-4.6-2.8-7.1c0,0,0,0,0,0H45c1.5,0,2.8-1.2,2.8-2.8v-28C47.8,4.4,46.6,3.1,45,3.1z M10.9,25.1\n\tl5-5.1l-5-5c-0.3-0.3-0.5-0.7-0.5-1.2s0.2-0.9,0.5-1.2c0.3-0.3,0.8-0.5,1.2-0.5s0.9,0.2,1.2,0.5l6.2,6.2c0.7,0.7,0.7,1.7,0,2.4\n\tl-6.2,6.3c-0.6,0.6-1.8,0.7-2.4,0C10.3,26.8,10.2,25.7,10.9,25.1z M24.9,20c0-0.9,0.8-1.7,1.7-1.7h9.9c0.9,0,1.7,0.8,1.7,1.7\n\ts-0.8,1.7-1.7,1.7h-9.9C25.7,21.7,24.9,20.9,24.9,20z"
    }, null, -1)
  ])))
}
export default { render: render }